import { IngredientAmount } from './IngredientAmount.jsx'

export const renderAmounts = (buy, amountClassName, onChange) => {
  return buy.amounts.map(entry => {
    const { unit } = entry

    return (
      <IngredientAmount
        className={amountClassName}
        entry={entry}
        key={unit}
        onChange={onChange && onChange.bind(null, unit)}
      />
    )
  })
}

export const IngredientAmounts = ({
  buy,
  className,
  amountClassName,
  onChange
}) => {
  const { amounts: [ amounts ] } = buy
  const hasSomeAmount = amounts.unit != 'u'
    || amounts.amount != 1
    || amounts.amountMax != null

  return (
    <span className={className}>
      { hasSomeAmount &&
         renderAmounts(buy, amountClassName, onChange) 
      }
    </span>
  )
}
